<script lang="ts" setup>
import type { TemplateData } from '~/composables/api/template/useFetchTemplate'

import type { SupportedCountryCode as SupportedCountryCodeForFlag } from '../Flag.vue'

const props = defineProps<{
  template: TemplateData
}>()

const { t } = useI18n()
const { getRegionName } = useIntl()

const legislationItems = computed(() =>
  (props.template.attributes.jurisdictions
    .map(({ code }) => // split england and wales to separate objects to display two rows in UI
      code === 'GB-EAW' ? ['GB-ENG', 'GB-WLS'] : code)
    .flat() as SupportedCountryCodeForFlag[])
    .map(code => ({
      code,
      text: getRegionName(code) || '',
    })),
)
</script>

<template>
  <div
    class="flex flex-col gap-6 text-sm"
  >
    <slot name="prepend" />
    <div class="flex justify-start gap-8">
      <div class="flex basis-1/2 flex-col gap-2">
        <span class="block font-semibold">
          {{ t('template.heading-legislation') }}
        </span>
        <ul
          v-if="legislationItems.length"
          class="flex flex-col gap-2"
        >
          <li
            v-for="({ code, text }) in legislationItems"
            :key="code"
            class="flex items-center gap-2 text-sm"
          >
            <Flag
              :width="20"
              :height="20"
              :country-code="code"
            />
            {{ text }}
          </li>
        </ul>
      </div>
      <div class="flex basis-1/2 flex-col gap-1.5">
        <span class="block font-semibold">
          {{ t('template.heading-language') }}
        </span>
        <TemplateLanguageFlag
          :template
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <slot name="append" />
  </div>
</template>
